import { ApiListResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { RequestDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import { useQuery, UseQueryOptions } from 'react-query';
import api from '@/utils/httpClient';

export const getRequests = () => {
  return api.get('/api/collaborationrequests/byrequester').then((response) => {
    const parsedData = response.data as ApiListResponse<RequestDto>;
    return parsedData.data;
  });
};

export const useGetRequests = (options?: UseQueryOptions<RequestDto[]>) => {
  return useQuery('requests', () => getRequests(), options);
};
